import { h, Component } from 'preact';
import { joinClasses, accessNested } from 'utils/utils';
import { Link } from 'components/core/link/link';
import s from 'components/shared/button/button.sss';

export default class Button extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hovering: false,
			menuOpen: false,
			regionSelectorOpen: false
		};

		this.toggleHover = this.toggleHover.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.menuOpen !== this.props.menuOpen) {
			this.setState({ menuOpen: this.props.menuOpen });
		}

		if (prevProps.regionSelectorOpen !== this.props.regionSelectorOpen) {
			this.setState({ regionSelectorOpen: this.props.regionSelectorOpen});
		}
	}

	toggleHover(hovering) {
		const isTouch = accessNested(this.props, 'client.isTouch');

		if (isTouch) return;

		this.setState({ hovering });
	}

	render({ data, extraClass, extraOnClick, onClick, link = true }, { hovering, menuOpen, regionSelectorOpen }) {
		const {
			label     = '',
			title     = '',
			type      = '',
			href      = '',
			pageId    = '',
			alt       = '',
			icon      = {},
			target    = '',
			ariaLabel = ''
		} = data;

		const showLine = type === 'underline' || type === 'menu' || type === 'ticket' || type === 'footer';
		const showLeftIcon = type === 'menu' || type === 'menuRegionSelector';
		const showRightIcon = type === 'regionSelector';
		const triggerAnimationEnd = type === 'underline';

		return (
			<Link
				class={joinClasses(
					s.button,
					s[type],
					extraClass,
					hovering && s.hovering,
					menuOpen ? s.menuOpen : s.menuClosed,
					regionSelectorOpen ? s.regionSelectorOpen : s.regionSelectorClosed
				)}
				HTMLTag={link ? 'a' : 'div'}
				role='button'
				href={href}
				pageId={pageId}
				target={href ? (target ? target : '_blank') : '_self'}
				title={title}
				ariaLabel={ariaLabel}
				extraOnClick={extraOnClick}
				onMouseEnter={this.toggleHover.bind(true, true)}
				onMouseLeave={this.toggleHover.bind(true, false)}
				renderCustomChild
			>
				{showLeftIcon && <img class={s.icon} src={icon.src} alt={icon.alt} />}
				<span class={s.label}>
					{label}
					{showLine && <div class={s.line} onTransitionEnd={() => {
						if (triggerAnimationEnd) {
							this.toggleHover(false);
						}
					}}/>}
				</span>
				{showRightIcon && <img class={s.icon} src={icon.src} alt={icon.alt} />}
			</Link>
		);
	}
}
